import api from '../api'
import capitalize from '../common/formatters/capitalize'
import { compareIds } from '../common/utils'

const initialState = {
  isLoading: false,
  list: [],
}

export default entityName => (state = initialState, action) => {
  switch (action.type) {
    case api[`get${capitalize(entityName)}s`].request:
      return {
        ...state,
        isLoading: true,
      }
    case api[`get${capitalize(entityName)}s`].success:
      return {
        ...state,
        isLoading: false,
        list: action.payload,
      }
    case api[`get${capitalize(entityName)}s`].failure:
      return {
        ...state,
        isLoading: false,
      }
    case api[`add${capitalize(entityName)}`].success:
      return {
        ...state,
        list: [...state.list, action.payload],
      }
    case api[`delete${capitalize(entityName)}`].success:
      return {
        ...state,
        list: state.list.filter(item => !compareIds(item.id, action.route)),
      }
    case api[`update${capitalize(entityName)}`].success:
      return {
        ...state,
        list: state.list.map(item => {
          if (compareIds(item.id, action.route)) {
            return action.payload
          }
          return item
        }),
      }
    default:
      return state
  }
}
